module.exports = __webpack_public_path__ + "static/img/7.b149a68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/7.png
// module id = iGSl
// module chunks = 0